//import React from 'react'
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function ITookATrip() {

    return (
        <>

        <p>I took a trip<br></br>
        Down the one way road to the outside of your house<br></br>
        To get a taste<br></br>
        Of the desert track where we find ourselves now<br></br>
        <br></br>
        A relic of a summer<br></br>
        Amnesia was my lover<br></br>
        My old low ride<br></br>
        It goes exactly where I wanna<br></br>
        I’d do it all over<br></br>
        I’d drive a little slower<br></br>
        Because looking back now<br></br>
        I hardly even even know ya<br></br>
        <br></br>
        I did you wrong<br></br>
        I did you wrong somehow<br></br>
        With your eyes on the line<br></br>
        Are you feeling the high now, now?<br></br>
        You sent me wrong<br></br>
        You sent me wrong, steer me away<br></br>
        Hands on the wheel<br></br>
        Because that was the deal that we made<br></br>
        <br></br>
        And we could drive<br></br>
        On the canyon wall where land runs deep for miles<br></br>
        When we arrive<br></br>
        And you see the light don’t forget to flash a smile<br></br>
        <br></br>
        Lesson of a journey man<br></br>
        Money in the other hand<br></br>
        Yeah that’s sweet<br></br>
        Take a fall for a couple grand<br></br>
        No one ever wins<br></br>
        No one ever asked why<br></br>
        Ever since those day<br></br>
        I only told white lies<br></br>
        <br></br>
        I did you wrong<br></br>
        I did you wrong back then<br></br>
        Everything we had<br></br>
        Was we everything we spent now, now<br></br>
        You sent me wrong<br></br>
        You sent me wrong,  steer me away<br></br>
        Hands on the wheel<br></br>
        Because that was the deal to ya, to ya, to ya…<br></br>
        <br></br>
        It’s in the way<br></br>
        It’s in the way<br></br>
        it’s in the way<br></br>
        <br></br>
        You said we’re in this together<br></br>
        Is what you said on the leather<br></br>
        Now I’m staring at you through the rear-view mirror, mirror, mirror<br></br>
        You said we’re in this together<br></br>
        Is what you said on the leather<br></br>
        Now I’m staring at you through the rear-view mirror, mirror, mirror, mirror</p>
        
        </> 
    )
}